/* Nordian — interacciones (nv) */
(function(){
  /* galería */
  document.querySelectorAll('[data-nv-gal]').forEach(function(g){
    var track=g.querySelector('.nv-gal__track'); if(!track) return;
    var thumbs=[].slice.call(g.querySelectorAll('.nv-gal__thumbs button'));
    var dots=[].slice.call(g.querySelectorAll('.nv-gal__dots i'));
    function mark(i){thumbs.forEach(function(t,k){t.classList.toggle('is-on',k===i)});dots.forEach(function(d,k){d.classList.toggle('is-on',k===i)});}
    thumbs.forEach(function(t,i){t.addEventListener('click',function(){track.scrollTo({left:track.clientWidth*i,behavior:'smooth'});mark(i);});});
    var raf;track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(function(){mark(Math.round(track.scrollLeft/Math.max(1,track.clientWidth)));});},{passive:true});
    mark(0);
  });
  /* barra fija */
  var bar=document.querySelector('[data-nv-sticky]');
  if(bar){
    document.body.classList.add('nv--sticky');
    var target=document.querySelector('[data-nv-buy]');
    var upd=function(){ if(!target){bar.classList.add('is-on');return;} var r=target.getBoundingClientRect(); bar.classList.toggle('is-on', r.bottom<0); };
    window.addEventListener('scroll',upd,{passive:true}); upd();
    bar.querySelectorAll('a[href="#comprar"]').forEach(function(a){a.addEventListener('click',function(e){var c=document.getElementById('comprar'); if(!c) return; e.preventDefault(); window.scrollTo({top:c.getBoundingClientRect().top+window.pageYOffset-80,behavior:'smooth'});});});
  }
  /* cuenta atrás hasta medianoche */
  document.querySelectorAll('[data-nv-timer]').forEach(function(el){
    var s=el.querySelectorAll('span');
    function tick(){var n=new Date(),e=new Date(n);e.setHours(24,0,0,0);var d=Math.max(0,e-n),h=Math.floor(d/36e5),m=Math.floor(d%36e5/6e4),x=Math.floor(d%6e4/1e3);
      if(s[0])s[0].textContent=String(h).padStart(2,'0');if(s[1])s[1].textContent=String(m).padStart(2,'0');if(s[2])s[2].textContent=String(x).padStart(2,'0');}
    tick(); setInterval(tick,1000);
  });
})();
